/**
 * maintenanceInterceptor
 *
 * Axios response error interceptor shared across all API instances (api, userApi, cmsApi, ssoApi).
 * When the backend is in maintenance mode it returns HTTP 503 with the body:
 *   { "status": "maintenance", "message": "<html string>" }
 *
 * This interceptor detects that response and dispatches a browser-level CustomEvent so that
 * the React tree (App.jsx → MainContent) can render the full-screen maintenance page without
 * any circular imports or Context changes.
 *
 * The error is always re-thrown so individual call-sites continue to handle it normally
 * (they just won't see maintenance-specific logic here — they'll see a rejected promise).
 */
const maintenanceInterceptor = (error) => {
  if (
    error.response?.status === 503 &&
    error.response?.data?.status === "maintenance"
  ) {
    const html = error.response.data.message || "";
    window.dispatchEvent(new CustomEvent("maintenance", { detail: html }));
  }
  return Promise.reject(error);
};

export { maintenanceInterceptor };
